import React from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-[#161616] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/71d8726e11bf2c1882a36ade8cdcc994.png" 
                alt="3DP Ankara Logo" 
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="text-gray-300 mb-4">
              Hassas imalatta güvenilir çözüm ortağınız. CNC torna, freze, kaynak ve 3D baskı hizmetleriyle tek çatı altında üretim.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-[#C1121F] rounded-lg flex items-center justify-center hover:bg-[#A00E1A] transition-colors">
                <i className="ri-facebook-fill text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-[#C1121F] rounded-lg flex items-center justify-center hover:bg-[#A00E1A] transition-colors">
                <i className="ri-instagram-line text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-[#C1121F] rounded-lg flex items-center justify-center hover:bg-[#A00E1A] transition-colors">
                <i className="ri-linkedin-fill text-white"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Hızlı Linkler</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-300 hover:text-[#C1121F] transition-colors">Anasayfa</Link></li>
              <li><Link to="/hakkimizda" className="text-gray-300 hover:text-[#C1121F] transition-colors">Hakkımızda</Link></li>
              <li><Link to="/hizmetler" className="text-gray-300 hover:text-[#C1121F] transition-colors">Hizmetler</Link></li>
              <li><Link to="/projeler" className="text-gray-300 hover:text-[#C1121F] transition-colors">Projeler</Link></li>
              <li><Link to="/kalite" className="text-gray-300 hover:text-[#C1121F] transition-colors">Kalite</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Hizmetlerimiz</h4>
            <ul className="space-y-3">
              <li><Link to="/hizmetler/cnc-torna" className="text-gray-300 hover:text-[#C1121F] transition-colors">CNC Torna</Link></li>
              <li><Link to="/hizmetler/cnc-dik-isleme" className="text-gray-300 hover:text-[#C1121F] transition-colors">CNC Dik İşleme</Link></li>
              <li><Link to="/hizmetler/universal-torna-freze" className="text-gray-300 hover:text-[#C1121F] transition-colors">Üniversal Torna &amp; Freze</Link></li>
              <li><Link to="/hizmetler/kaynak" className="text-gray-300 hover:text-[#C1121F] transition-colors">Kaynak</Link></li>
              <li><Link to="/hizmetler/3d-printer" className="text-gray-300 hover:text-[#C1121F] transition-colors">3D Printer</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6">İletişim</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-[#C1121F] text-xl mt-1"></i>
                <div>
                  <p className="text-gray-300">1459. Cad, İvedik OSB</p>
                  <p className="text-gray-300">Özanadolu Sanayi Sitesi No:3</p>
                  <p className="text-gray-300">06480 Yenimahalle/Ankara</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-[#C1121F] text-xl"></i>
                <a href="tel:03123945635" className="text-gray-300 hover:text-[#C1121F] transition-colors">0312 394 56 35</a>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-[#C1121F] text-xl"></i>
                <a href="mailto:info@3dpmakina.com" className="text-gray-300 hover:text-[#C1121F] transition-colors">info@3dpmakina.com</a>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-time-line text-[#C1121F] text-xl"></i>
                <p className="text-gray-300">Pzt-Cum: 08:00-18:00</p>
              </div>
            </div>
          </div>

        </div>

        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 3DP Ankara. Tüm hakları saklıdır.
            </p>
            <div className="flex items-center space-x-6 mt-4 md:mt-0">
              <Link to="/kvkk" className="text-gray-400 hover:text-[#C1121F] text-sm transition-colors">KVKK</Link>
              <Link to="/gizlilik" className="text-gray-400 hover:text-[#C1121F] text-sm transition-colors">Gizlilik</Link>
              <a href="https://cdco.com.tr" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#C1121F] text-sm transition-colors">Bu web tasarımı CDCO tarafından yapılmıştır</a>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};
